import userApi from '@/servies/user'
import { ElMessage as Message } from 'element-plus'
import { logout } from '@/servies/classPostNewApi'

let refreshTimer = null
let isTokenRefreshEnabled = false

function getLoginData() {
    try {
        const loginData = sessionStorage.getItem('loginData')
        return loginData && loginData !== 'null' ? JSON.parse(loginData) : null
    } catch (error) {
        return null
    }
}

function hasAccessToken() {
    const loginData = getLoginData()
    return Boolean(loginData && loginData.accessToken)
}

/**
 * 启动 token 自动刷新
 * @param {number} expiresIn - token 过期时间（秒）
 */
export function startTokenRefresh(ttl) {
    // 清除之前的定时器
    stopTokenRefresh()

    if (!hasAccessToken()) {
        return
    }

    isTokenRefreshEnabled = true

    // if (!expiresIn || expiresIn <= 0) {
    //     console.warn('Invalid token expiration time')
    //     return
    // }

    // 在 token 过期前 5 分钟刷新（如果过期时间小于 5 分钟，则在过期前 30 秒刷新）
    // const refreshBeforeExpire = expiresIn > 300 ? 300 : Math.max(30, expiresIn * 0.1)
    // const refreshTime = (expiresIn - refreshBeforeExpire) * 1000 // 转换为毫秒

    // console.log(`Token will be refreshed in ${refreshTime / 1000} seconds (${Math.floor(refreshTime / 60000)} minutes)`)

    refreshTimer = setTimeout(async () => {
        if (!isTokenRefreshEnabled || !hasAccessToken()) {
            stopTokenRefresh()
            return
        }
        await handleTokenRefresh()
    }, 1000 * 60)
}

/**
 * 停止 token 自动刷新
 */
export function stopTokenRefresh() {
    console.log('Token refresh timer stopped', refreshTimer)
    isTokenRefreshEnabled = false
    if (refreshTimer) {
        clearTimeout(refreshTimer)
        refreshTimer = null
    }
}

/**
 * 手动刷新 token
 */
export async function handleTokenRefresh(response) {
    if (!isTokenRefreshEnabled || !hasAccessToken()) {
        stopTokenRefresh()
        return false
    }

    try {
        // const refreshToken = sessionStorage.getItem('refreshToken')

        // if (!refreshToken) {
        //     console.error('No refresh token found')
        //     handleTokenExpired()
        //     return false
        // }

        // console.log('Refreshing token...')

        // 调用刷新 token 接口
        const res = await userApi.getTokenTtl()
        console.log(res, 'res🚀----')
        if (!isTokenRefreshEnabled || !hasAccessToken()) {
            stopTokenRefresh()
            return false
        }
        if (res.data.ttl <= 0) {
            handleTokenExpired()
            return false
        }
        // // 更新 sessionStorage
        // sessionStorage.setItem('token', res.accessToken)
        // sessionStorage.setItem('refreshToken', res.refreshToken)
        // sessionStorage.setItem('accessTokenExpiresIn', res.accessTokenExpiresIn)
        // sessionStorage.setItem('refreshTokenExpiresIn', res.refreshTokenExpiresIn)

        // console.log('Token refreshed successfully')

        // // 重新启动定时器
        startTokenRefresh(res.data)

        return true

    } catch (error) {
        console.error('Failed to refresh token:', error)
        if (!isTokenRefreshEnabled || !hasAccessToken()) {
            stopTokenRefresh()
            return false
        }
        handleTokenExpired()
        return false
    }
}

/**
 * 处理 token 过期
 */
export async function handleTokenExpired() {
    // 清除所有 token 相关信息
    sessionStorage.removeItem('entityData')
    sessionStorage.removeItem('loginData')
    sessionStorage.removeItem('profile')
    sessionStorage.removeItem('serverDate')
    sessionStorage.removeItem('firstLogin');
    // 停止刷新定时器
    stopTokenRefresh()

    // 提示用户重新登录
    Message.warning('登录已过期，请重新登录')
    // 跳转到登录页
    try {

        logout();
        // if (window.location.pathname !== '/login') {
        setTimeout(() => {
            window.location.href = '/#/login'
        }, 1500)
        // }
    } catch (error) {
        console.error('Failed to redirect to login page:', error)
    }
    return false
}

/**
 * 初始化 token 刷新（用于页面刷新或首次加载时恢复定时器）
 */
export function initTokenRefresh() {
    const loginData = getLoginData()
    console.log(loginData, 'loginData🚀----')
    if (loginData && loginData.accessToken) {
        isTokenRefreshEnabled = true
        handleTokenRefresh()
        startTokenRefresh()
    }
}
